import { pdfjs } from 'react-pdf';

/**
 * Configure PDF.js worker source globally.
 *
 * We use jsDelivr CDN to load the PDF.js worker because:
 * - react-pdf@10.x bundles pdfjs-dist@5.x which uses .mjs worker files
 * - jsDelivr provides better reliability and CORS support than unpkg
 * - CDN approach avoids bundling the worker, similar to how other dependencies load scripts from external sources at runtime
 * - Smaller bundle size (no need to copy worker file via webpack)
 *
 * The worker version is automatically matched to the pdfjs-dist version bundled with react-pdf.
 *
 * This function is idempotent and safe to call multiple times (e.g., during HMR hot reloads).
 * It's designed to be called at module-level for global library configuration, not in React useEffect.
 */
export const initializePdfjsWorker = (): void => {
  // Guard: only initialize if not already set (prevents re-init during HMR)
  if (pdfjs.GlobalWorkerOptions.workerSrc) {
    return;
  }

  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
};
